import { useState, useCallback } from 'react';
import { KnightKey, FaeKey } from '../../types';

export type PanelType = 'anvil' | 'merlin' | 'morgana' | 'nimue' | 'source' | null;

export const usePanelState = () => {
    const [activePanel, setActivePanel] = useState<PanelType>(null);
    
    const [selectedCompendiumKnight, setSelectedCompendiumKnight] = useState<KnightKey | null>(null);
    const [selectedCompendiumFae, setSelectedCompendiumFae] = useState<FaeKey | null>(null);

    const closeAllPanels = useCallback(() => {
        setActivePanel(null);
        setSelectedCompendiumKnight(null);
        setSelectedCompendiumFae(null);
    }, []);

    const activatePanel = useCallback((panel: PanelType) => {
        setSelectedCompendiumKnight(null);
        setSelectedCompendiumFae(null);
        setActivePanel(panel);
    }, []);

    return {
        activePanel,
        setActivePanel,
        selectedCompendiumKnight, setSelectedCompendiumKnight,
        selectedCompendiumFae, setSelectedCompendiumFae,
        closeAllPanels,
        activatePanel
    };
};
